import moment from 'moment';


export const timeElapsedFunction = (updatedAt) => {
  const diffSeconds = moment().diff(updatedAt, 'seconds');
  const diffMinutes = moment().diff(updatedAt, 'minutes');
  const diffHours = moment().diff(updatedAt, 'hours');
  const diffDays = moment().diff(updatedAt, 'days');
  const diffMonths = moment().diff(updatedAt, 'months');
  const diffYears = moment().diff(updatedAt, 'years');

  if (diffSeconds < 60) {
    return moment(updatedAt).startOf('second').fromNow();
  }
  if (diffMinutes < 60) {
    return moment(updatedAt).startOf('minute').fromNow();
  }
  if (diffHours > 0 && diffHours < 24) {
    return moment(updatedAt).startOf('hour').fromNow();
  }
  if (diffDays > 0 && diffDays < 30) {
    return moment(updatedAt).startOf('day').fromNow();
  }
  if (diffMonths > 0 && diffMonths < 12) {
    return moment(updatedAt).startOf('month').fromNow();
  }
  if (diffYears > 1) {
    return (moment(updatedAt).startOf('year').fromNow());
  }
  return moment(updatedAt).startOf('minute').fromNow();
};